module.exports = __webpack_public_path__ + "img/enquiry-reservations.6c33d7ac.svg";